"use strict";

exports.__esModule = true;
exports.CalendarRoutes = CalendarRoutes;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _System = require("../../../System");
var _CalendarScreen = require("../CalendarScreen");
var _ScheduleListScreen = require("../ScheduleListScreen");
var _CreateScheduleScreen = require("../CreateScheduleScreen");
var _UpdateScheduleScreen = require("../UpdateScheduleScreen");
var _CalendarSettingsScreen = require("../CalendarSettingsScreen");
var _CalendarLoader = require("../CalendarLoader");
var _CalendarContext = require("../CalendarContext");
var _LoadingMediator = require("../../Core/LoadingMediator");
var _CheckAccessRoute = require("../../Core/CheckAccessRoute");
var _reactRouterPathGroup = require("../../../Utils/reactRouterPathGroup");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var CALENDAR_PATHS = [(0, _System.getScreenPath)("CalendarSettings"), (0, _System.getScreenPath)("CreateSchedule"), (0, _System.getScreenPath)("UpdateSchedule"), (0, _System.getScreenPath)("ScheduleList"), (0, _System.getScreenPath)("Calendar")];

/**
 * Plant State Activities Routes
 */
function CalendarRoutes() {
  var active = (0, _reactRouterPathGroup.usePathGroupActive)(CALENDAR_PATHS);
  if (!active) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(_CalendarLoader.CalendarLoader, null, function (props) {
    return /*#__PURE__*/_react["default"].createElement(_LoadingMediator.LoadingMediator, props, function (calendar) {
      return /*#__PURE__*/_react["default"].createElement(_CalendarContext.CalendarContext.Provider, {
        calendar: calendar
      }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Routes, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
        path: (0, _System.getScreenPath)("CalendarSettings"),
        element: /*#__PURE__*/_react["default"].createElement(_CheckAccessRoute.CheckAccessRoute, {
          permission: "EDIT_CALENDAR",
          component: _CalendarSettingsScreen.CalendarSettingsScreen
        })
      }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
        path: (0, _System.getScreenPath)("CreateSchedule"),
        element: /*#__PURE__*/_react["default"].createElement(_CheckAccessRoute.CheckAccessRoute, {
          permission: "EDIT_CALENDAR",
          component: _CreateScheduleScreen.CreateScheduleScreen
        })
      }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
        path: (0, _System.getScreenPath)("UpdateSchedule"),
        element: /*#__PURE__*/_react["default"].createElement(_CheckAccessRoute.CheckAccessRoute, {
          permission: "EDIT_CALENDAR",
          component: _UpdateScheduleScreen.UpdateScheduleScreen
        })
      }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
        path: (0, _System.getScreenPath)("ScheduleList"),
        element: /*#__PURE__*/_react["default"].createElement(_CheckAccessRoute.CheckAccessRoute, {
          permission: "VIEW_CALENDAR",
          component: _ScheduleListScreen.ScheduleListScreen
        })
      }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
        path: (0, _System.getScreenPath)("Calendar"),
        element: /*#__PURE__*/_react["default"].createElement(_CheckAccessRoute.CheckAccessRoute, {
          permission: "VIEW_CALENDAR",
          component: _CalendarScreen.CalendarScreen
        })
      })));
    });
  });
}